module.exports = __webpack_public_path__ + "img/scop4.e89341a3.jpg";